// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBQJFSReh4JnH_Nk6GpwY8nJTqKEboxjDE",
  authDomain: "hi-kid.firebaseapp.com",
  projectId: "hi-kid",
  storageBucket: "hi-kid.firebasestorage.app",
  messagingSenderId: "149217734464",
  appId: "1:149217734464:web:6a2a3e0b7e66899f9a54a5",
  measurementId: "G-TZY9HEVPZK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only if supported (prevents crashes from ad blockers / privacy extensions)
let analytics = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
}).catch(() => {
  // Analytics not available - app continues to work normally
});

export { app, analytics };
